import api from 'api'
import { IMyCertificate } from 'models/certificate.model'

export interface GetMyCertificateRequest {
  certificateId: number | string
  courseId?: number | string | null
}

export const getCertificateData = ({
  certificateId,
  courseId,
}: GetMyCertificateRequest) => {
  return api.get(`/certificates/${certificateId}`, { params: { courseId } })
}

const getMyCertificate = ({
  certificateId,
  courseId,
}: GetMyCertificateRequest) => {
  return api
    .get(`/certificates/${certificateId}`, {
      params: { courseId },
    })
    .then(({ data }): IMyCertificate => {
      const signers =
        data.data.attributes.certificate.data.attributes.signersAttributes.data.map(
          ({ attributes }: any) => attributes
        )

      const aux = {
        ...data.data.attributes,
        certificate: {
          ...data.data.attributes.certificate.data.attributes,
          signersAttributes: signers,
        },
      }

      return aux
    })
}

export default getMyCertificate
